<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SP"></ad-group-select>
        <gj-select
            v-model="filter.status"
            :options="AdNegTargetEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-lazy-input
            v-model="filter.keyword"
            placeholder="品牌/ASIN"
            width="150px"
        ></gj-lazy-input>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :helpName="helpName"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
          <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add">
        新增否定商品投放
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdNegTargetEnum.SP.status.ENABLE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns"
          :sort-gjtable="$refs.gjTable"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template>
      </gj-tool-group>
      <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :loading="loading"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          :data="tableData"
          sortable="custom"
          :pagination="pagination"
          :selectable="notEqSelectable('state', AdNegTargetEnum.SP.status.ARCHIVE)"
          :scroll-y="{mode: 'default', gt: 100 }"
          :columns="columns"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:negTargetName="{row}">
          <template v-if="row.resolvedExpressionValueList && row.resolvedExpressionValueList.length > 0">
            <gj-tooltip :text-line="1">
              <template #content>
                <span v-for="(item, i) in row.resolvedExpressionValueList" :key="i" style="padding-right: 5px">
                  <template v-if="item.type === 'ASIN_SAME_AS'">
                    商品：<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
                  </template>
                  <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                    {{ item | resolveType }}
                  </template>
                  <template v-else>-</template>
                </span>
              </template>
              <span v-for="(item, i) in row.resolvedExpressionValueList" :key="i" :text-line="1" style="padding-right: 5px">
                <template v-if="item.type === 'ASIN_SAME_AS'">
                  商品：<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
                </template>
                <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                  {{ item | resolveType }}
                </template>
                <template v-else>-</template>
              </span>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin, resizeMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
  import {AdNegTargetEnum, AdLog} from "../../../common/enum";
  import AppAddSpAdNegTarget from "../../common/modal/add/neg-target/add-ad-neg-target";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {getSpAdNegTargetPage, updateSpAdNegTarget, SP} from "@/api/ad";
  import {adStore} from "../../../common/store";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
  import {LOG_OP_TYPE} from "../../../common/options";
import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";

  export default {
    name: "app-sp-ad-neg-target",
    components: {AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, resizeMixin,
      tableNameMixin, selectionMixin, adBaseDataMixin,
      queryMixin, currencySymbolMixin, isMeaningfulMixin, initDateMixin
    ],
    created() {
      this.columns = [
        adFields.negTargetName,
        {...adFields.servingStatus, field: 'option:state', options: AdNegTargetEnum.SP.statusOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // {...adFields.startDate, help: null},
        adFields.op,
      ].filter(e => e !== null);
    },
    inject: [ 'getCornerMark' ],
    data() {
      return {
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdNegTargetEnum: AdNegTargetEnum,
        // filter
        filter: {
          status: AdNegTargetEnum.SP.statusNew.ENABLE,
          keyword: null,
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-neg-target',
        notStorage: true
      }
    },
    filters: {
      resolveType(val) {
        switch (val.type) {
          case 'ASIN_SAME_AS':
            return `商品：${val.value}`;
          case 'ASIN_CATEGORY_SAME_AS':
            return `分类：${val.value}`;
          case 'ASIN_PRICE_BETWEEN':
            const sign = val.value.split('-');
            return `价格：${adStore.SP.currencySymbol}${sign[0]}-${adStore.SP.currencySymbol}${sign[1]}`;
          case 'ASIN_BRAND_SAME_AS':
            return `品牌：${val.value}`;
          case 'ASIN_PRICE_LESS_THAN':
            return `价格：低于${adStore.SP.currencySymbol}${val.value}`;
          case 'ASIN_PRICE_GREATER_THAN':
            return `价格：高于${adStore.SP.currencySymbol}${val.value}`;
          case 'ASIN_REVIEW_RATING_LESS_THAN':
            return `星级：低于${val.value}星`;
          case 'ASIN_REVIEW_RATING_BETWEEN':
            let sign1 = val.value.split('-');
            return `星级：${sign1[0]}星-${sign1[1]}星`;
          case 'ASIN_REVIEW_RATING_GREATER_THAN':
            return `星级：高于${val.value}星`;
          case 'ASIN_IS_PRIME_SHIPPING_ELIGIBLE':
            return `配送：${val.value === 'false' ? '不' : ''}具备Prime资格`;
          default:
            break;
        }
        return `${val.type}=${val.value}`
      }
    },
    methods: {
      // 投放修改
      async negativeTargetsEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.negativeTargetsEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.targetId === item.targetId);
            Object.assign(element, item);
          });
        } catch (error) {
          //
        }
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          filter: {
            status: AdNegTargetEnum.SP.statusNew.ENABLE,
            keyword: null
          }
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动 & 广告组
        let campaignIds = this.campaignIds || [];
        let groupIds = this.groupIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        this.groupId && (groupIds = [ this.groupId ]);
        // 构造查询参数
        const params = {
          model: {
            campaignIds,
            groupIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            expressionValue: this.filter.keyword,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        try {
          let { data } = await SP.negativeTargetsPage(params);
          let tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.tableData = tableData;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          this.pagination = this.getPagination(data);
        } catch (error) {
          //
        } finally {
          this.loading = false;
        }
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SP', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      add() {
        this.$gjCreate(AppAddSpAdNegTarget, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          }, 
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                targetId: e.targetId,
                state: AdNegTargetEnum.SP.status.ARCHIVE
              }))
              try {
                await this.negativeTargetsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.resolvedExpressionValueList[0].value;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            groupId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.negativeDelivery,
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     groupId: this.groupId,
        //     name: '',
        //     opId: isMeaningful(row) ? row.targetId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: LOG_OP_TYPE.SP.NEG_PRODUCT_TARGET
        //   }
        // });
      },
    }
  }
</script>

<style scoped>

</style>
